import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
export function SisterSiteCallout() {
  return <section className="py-12 bg-white" data-id="element-211">
      <div className="container mx-auto px-4" data-id="element-212">
        <a href="https://www.swedenmark.ai" target="_blank" rel="noopener noreferrer" className="group block max-w-4xl mx-auto p-8 md:p-10 rounded-2xl border border-gray-200 bg-gradient-to-br from-gray-50 to-blue-50/50 hover:border-blue-300 hover:shadow-md transition-all" data-id="element-213">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-214">
            <div className="flex-1" data-id="element-215">
              <p className="text-gray-700 text-lg mb-2" data-id="element-216">
                Looking to automate operations, accelerate revenue, or transform
                how your business runs with AI?
              </p>
              <p className="text-gray-500 text-sm" data-id="element-217">
                Our sister firm handles AI automation and growth consulting.
              </p>
            </div>
            <div className="flex items-center gap-2 text-blue-600 font-semibold whitespace-nowrap group-hover:gap-3 transition-all" data-id="element-218">
              Visit Swedenmark AI
              <ArrowUpRightIcon size={18} data-id="element-219" />
            </div>
          </div>
        </a>
      </div>
    </section>;
}